<template>
<div class="box" style="margin-top: 1.2rem">
  <div>
    <span>服务</span>
    <p class="p1">月度会员</p>
  </div>
  <div>
    <span>价格</span>
    <p class="p2">5000 FBEE</p>
  </div>
  <div>
    <span>时间</span>
    <p class="p2">2018.03.20 09:25:28</p>
  </div>
</div>
</template>

<script>
export default {
  name: 'fbeePayHistronyById'
}
</script>

<style scoped>
.box>div{
  width: 100%;
  height: 2rem;
  position: relative;
}
.box>div>span{
  font-family: PingFangSC-Regular;
  font-size: 0.373rem;
  color: #C6C5CC;
  position: absolute;
  left: 0.533rem;
  top: 0.32rem;
}
.box>div>.p1{
  font-family: PingFangSC-Regular;
  font-size: 0.8rem;
  color: #584F60;
  position: absolute;
  left: 0.533rem;
  top: 0.8rem;
}
.box>div>.p2{
  font-family: PingFangSC-Regular;
  font-size: 0.427rem;
  color: #584F60;
  position: absolute;
  left: 0.533rem;
  top: 0.987rem;
}
</style>



// WEBPACK FOOTER //
// src/components/fbeePayHistronyById.vue